module.exports = __webpack_public_path__ + "img/beam.aa25b416.png";